"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertFilters = exports.convertMeasureFilter = exports.convertFilter = exports.convertRankingFilter = exports.convertMeasureValueFilter = exports.convertRelativeDateFilter = exports.convertAbsoluteDateFilter = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var ObjRefConverter_1 = require("../ObjRefConverter");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var utils_1 = require("../utils");
function convertAttributeFilter(filter) {
    /*
     * When sending either positive or negative filter and the in/notIn is empty, backend will bomb
     * with "Cannot parse MAQL expression(s): %s". Previously code was only throwing away empty negative
     * filters.
     */
    if (sdk_model_1.filterIsEmpty(filter)) {
        return null;
    }
    if (!sdk_model_1.isPositiveAttributeFilter(filter)) {
        utils_1.assertNoNulls(filter.negativeAttributeFilter.notIn);
        return {
            negativeAttributeFilter: {
                displayForm: ObjRefConverter_1.toBearRef(filter.negativeAttributeFilter.displayForm),
                notIn: filter.negativeAttributeFilter.notIn,
            },
        };
    }
    utils_1.assertNoNulls(filter.positiveAttributeFilter.in);
    return {
        positiveAttributeFilter: {
            displayForm: ObjRefConverter_1.toBearRef(filter.positiveAttributeFilter.displayForm),
            in: filter.positiveAttributeFilter.in,
        },
    };
}
function convertAbsoluteDateFilter(filter) {
    var absoluteDateFilter = filter.absoluteDateFilter;
    if (absoluteDateFilter.from === undefined || absoluteDateFilter.to === undefined) {
        return null;
    }
    return {
        absoluteDateFilter: {
            dataSet: ObjRefConverter_1.toBearRef(absoluteDateFilter.dataSet),
            from: String(absoluteDateFilter.from),
            to: String(absoluteDateFilter.to),
        },
    };
}
exports.convertAbsoluteDateFilter = convertAbsoluteDateFilter;
function convertRelativeDateFilter(filter) {
    var relativeDateFilter = filter.relativeDateFilter;
    if (relativeDateFilter.from === undefined || !relativeDateFilter.to === undefined) {
        return null;
    }
    return {
        relativeDateFilter: {
            dataSet: ObjRefConverter_1.toBearRef(relativeDateFilter.dataSet),
            granularity: relativeDateFilter.granularity,
            from: Number(relativeDateFilter.from),
            to: Number(relativeDateFilter.to),
        },
    };
}
exports.convertRelativeDateFilter = convertRelativeDateFilter;
// Bear supports up to 6 decimal places
var MAX_DECIMAL_PLACES = 6;
function trimNumberToSupportedPrecision(num) {
    return parseFloat(num.toFixed(MAX_DECIMAL_PLACES));
}
function trimConditionToSupportedPrecision(condition) {
    if (sdk_model_1.isComparisonCondition(condition)) {
        var nullValuesProp = !isNil_1.default(condition.comparison.treatNullValuesAs)
            ? { treatNullValuesAs: condition.comparison.treatNullValuesAs }
            : {};
        return {
            comparison: tslib_1.__assign({ operator: condition.comparison.operator, value: trimNumberToSupportedPrecision(condition.comparison.value) }, nullValuesProp),
        };
    }
    else {
        var nullValuesProp = !isNil_1.default(condition.range.treatNullValuesAs)
            ? { treatNullValuesAs: condition.range.treatNullValuesAs }
            : {};
        return {
            range: tslib_1.__assign({ operator: condition.range.operator, from: trimNumberToSupportedPrecision(condition.range.from), to: trimNumberToSupportedPrecision(condition.range.to) }, nullValuesProp),
        };
    }
}
function convertMeasureValueFilter(filter) {
    if (filter.measureValueFilter.condition === undefined) {
        return null;
    }
    return {
        measureValueFilter: {
            measure: ObjRefConverter_1.toScopedBearRef(filter.measureValueFilter.measure),
            condition: trimConditionToSupportedPrecision(filter.measureValueFilter.condition),
        },
    };
}
exports.convertMeasureValueFilter = convertMeasureValueFilter;
function convertRankingFilter(filter) {
    var _a = filter.rankingFilter, measure = _a.measure, attributes = _a.attributes, operator = _a.operator, value = _a.value;
    return {
        rankingFilter: {
            measures: [ObjRefConverter_1.toScopedBearRef(measure)],
            attributes: attributes === null || attributes === void 0 ? void 0 : attributes.map(ObjRefConverter_1.toScopedBearRef),
            operator: operator,
            value: value,
        },
    };
}
exports.convertRankingFilter = convertRankingFilter;
function convertFilter(filter) {
    if (sdk_model_1.isMeasureValueFilter(filter)) {
        return convertMeasureValueFilter(filter);
    }
    if (sdk_model_1.isRankingFilter(filter)) {
        return convertRankingFilter(filter);
    }
    return convertMeasureFilter(filter);
}
exports.convertFilter = convertFilter;
function convertMeasureFilter(filter) {
    if (sdk_model_1.isAttributeFilter(filter)) {
        return convertAttributeFilter(filter);
    }
    else if (sdk_model_1.isAbsoluteDateFilter(filter)) {
        return convertAbsoluteDateFilter(filter);
    }
    else {
        return convertRelativeDateFilter(filter);
    }
}
exports.convertMeasureFilter = convertMeasureFilter;
function convertFilters(filters) {
    return filters ? compact_1.default(filters.map(convertFilter)) : [];
}
exports.convertFilters = convertFilters;
//# sourceMappingURL=FilterConverter.js.map